module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL3-if-one-correct.20fbec9c.mp3";